module.exports = __webpack_public_path__ + "media/images/icons/filled/fire-f7699edf152eaba8797a7c4b7d147bbb.svg";